module.exports = __webpack_public_path__ + "static/media/newdesigners.228c7138.png";